
import CenteredLayout from '@/components/layouts/CenteredLayout.vue'
import { useAlerts } from '@/mixins'
import auth from '@/plugins/firebase/auth'
import { defineComponent, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { CenteredLayout },
  setup() {
    const { t } = useI18n()
    const { message: notification } = useAlerts('success')
    const route = useRoute()
    const processing = ref(true)
    const { mode, oobCode: actionCode, lang, continueUrl } = route.query

    onMounted(async () => {
      try {
        await auth.verifyEmail(actionCode as string)
        processing.value = false
        notification.value.type = 'success'
        notification.value.message = t('verify_email.success_message')
      } catch (e) {
        console.error(e)
        processing.value = false
        notification.value.type = 'error'
        notification.value.message = t('verify_email.error_message')
      }
    })

    return {
      processing,
      mode,
      notification,
      actionCode,
      lang,
      continueUrl
    }
  }
})
